import { eventChannel } from 'redux-saga'
import { takeLatest, put, fork, take, cancel, cancelled, call } from 'redux-saga/effects'
import { interviewRequestDetailsView } from '../../reducks'

// Polling every 10 minutes
const pollingPeriod = 10 * 60 * 1000

function* initPollingSaga({ meta }) {
  // Start the polling task in the background
  const pollingTask = yield fork(backgroundPolling, meta)
  // Listen for the reset action and cancel the background task
  yield take(interviewRequestDetailsView.INTERVIEW_REQUEST_POLLING_END)
  yield cancel(pollingTask)
}

function* backgroundPolling(meta) {
  const channel = yield call(pollingChannel, meta.id, meta.companySlug, meta.candidateId)
  try {
    while (true) {
      const action = yield take(channel)
      yield put(action)
    }
  } finally {
    // Executes when the background task is cancelled
    if (yield cancelled()) {
      channel.close()
    }
  }
}

function pollingChannel(interviewRequestId, companySlug, candidateId) {
  return eventChannel(emitter => {
    // Create the interval and execute the polling when triggered
    const pollingInterval = setInterval(() => {
      emitter(interviewRequestDetailsView.interviewRequestPollingExecute(interviewRequestId, companySlug, candidateId))
    }, pollingPeriod)

    return () => {
      // Cancel the interval
      clearInterval(pollingInterval)
    }
  })
}

export default function* watchInterviewRequestDetailsChannel() {
  yield takeLatest(interviewRequestDetailsView.INTERVIEW_REQUEST_POLLING_INIT, initPollingSaga)
}
